import { baseUrl } from "../apiConfig";
import nsiLogo from "./nsi-logo.png";
import headerLogo from "./nsi-logo.png";
import nsiLogoWhite from "./nsi_logo_white.png";
import placeholderPerson from "./placeholder-person.png";
import logoIfic from "./logo-ific.png";

export function autoPrefixUrls(s: string) {
  if (!s.includes("data:image")) {
    return baseUrl + s;
  } else {
    return s;
  }
}

const assets = {
  images: {
    nsiLogo: autoPrefixUrls(nsiLogo),
    nsiLogoWhite: autoPrefixUrls(nsiLogoWhite),
    placeholderPerson: autoPrefixUrls(placeholderPerson),
    headerLogo: autoPrefixUrls(headerLogo),
    logoIfic: autoPrefixUrls(logoIfic),
  },
};

export default assets;
